module.exports = __webpack_public_path__ + "assets/asa.3c1917252e24a8bdc5245e5b04c96547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/asa.jpg
// module id = 620
// module chunks = 0